import React from "react";
import BearSvg from "../../assets/Bear.svg";

export default function Bear() {
  return <img src={BearSvg} className="bear" alt="Media Arts Lab" />;
}
